import React, {Fragment} from 'react'
import {categories, getCategory} from "../models";
import WorkflowCategoryChip from './WorkflowCategoryChip';


export const WorkflowTaskCategory = ({
  value, model, size
}) => {
  const categoryModel = model || getCategory(value);
  return categoryModel ?
    <Fragment><WorkflowCategoryChip category={model || value} size={size} /> &nbsp;{categoryModel.value}</Fragment> :
    <span>N/A</span>
}
